let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4cMzD")).then(() => parcelRequire('9Yoaw'));